export { setDurationMessage } from './setDurationMessage';
export { setInfoMessage } from './setInfoMessage';



// WEBPACK FOOTER //
// ./src/components/TransferTooltip/utils/index.js